<div class="container" style="align-content: center;">
    <div class="cadastro-body">
      <div style="margin: 10px;">
  
        <div class="row col-md-12">
          <p class="cor-referencia titulo">CADASTRO CHAVE PIX</p>
        </div>
  
        <div class="row col-md-12">
          <form class="col-md-12" [formGroup]="formPix" (ngSubmit)="enviarDados()">
            <div class="row select-tipo-chave">
              <label class="cor-referencia">Qual o tipo da conta de destino?</label>
              <ng-multiselect-dropdown
                  [placeholder]="'Selecione'"
                  [data]="dropdownList"
                  [(ngModel)]="selectedItems"
                  [settings]="dropdownSettings"
                  (onSelect)="onItemSelect($event)"
                  formControlName="tipoChave"
              >
              </ng-multiselect-dropdown>
          </div>
  
            <div class="row col-md-12">
              <div [ngSwitch]="tipoChavePix" class="col-md-12">
                <label class="cor-referencia">Chave*</label>
                <input *ngSwitchCase="1" class="form-control" [textMask]="{mask: cpfMask}" type="string" formControlName="chave" />
                <input *ngSwitchCase="2" class="form-control" [textMask]="{mask: cnpjMask}" type="string" formControlName="chave" />
                <input *ngSwitchCase="3" class="form-control" [textMask]="{mask: celularMask}" type="string" formControlName="chave" />
                <input *ngSwitchCase="4" class="form-control" type="string" formControlName="chave" />
                <input *ngSwitchCase="5" class="form-control" [textMask]="{mask: chaveAleMAsk}" type="string" formControlName="chave" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" style="margin: 10px;">
                <button [disabled]="!formPix.valid" class="btn btn-cadastrar">Cadastrar</button>
              </div>
            </div>
  
          </form>
        </div>
      </div>
    </div>
  </div>
  